import { render, staticRenderFns } from "./HKPage.vue?vue&type=template&id=2baea7f6&scoped=true"
import script from "./HKPage.vue?vue&type=script&lang=js"
export * from "./HKPage.vue?vue&type=script&lang=js"
import style0 from "./HKPage.vue?vue&type=style&index=0&id=2baea7f6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2baea7f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/actions-runner/_work/treasurenet-tnservices-producerPlatform-fe/treasurenet-tnservices-producerPlatform-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2baea7f6')) {
      api.createRecord('2baea7f6', component.options)
    } else {
      api.reload('2baea7f6', component.options)
    }
    module.hot.accept("./HKPage.vue?vue&type=template&id=2baea7f6&scoped=true", function () {
      api.rerender('2baea7f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/authentication/IdentityKYC/components/HKPage.vue"
export default component.exports